import "./Pages.css";
const Home=()=>{
    return (
    <div className="home">

      {/* Hero Section */}
      <section className="hero">
        <h1>Empowering Your E-commerce Business</h1>

        <p>
          We provide complete E-commerce Solutions, Order Management Systems,
          and Communication Services to help businesses automate operations,
          improve customer engagement, and accelerate growth.
        </p>

        <button>Get Started</button>
      </section>

      {/* Services */}
      <section className="services">

        <h2>Our Services</h2>

        <div className="service-container">

          <div className="service-card">
            <h3>🛒 E-commerce Solutions</h3>
            <p>
              Build and manage your online store with powerful, scalable,
              and secure e-commerce solutions tailored to your business.
            </p>
          </div>

          <div className="service-card">
            <h3>📦 Order Management System</h3>
            <p>
              Simplify order processing, inventory tracking, shipping,
              returns, and customer management from a single platform.
            </p>
          </div>

          <div className="service-card">
            <h3>📩 SMS Services</h3>
            <p>
              Send transactional and promotional SMS including OTPs,
              order updates, delivery notifications, and marketing campaigns.
            </p>
          </div>

          <div className="service-card">
            <h3>📧 Email Services</h3>
            <p>
              Automate order confirmations, invoices, newsletters,
              promotional emails, and customer communication.
            </p>
          </div>

          <div className="service-card">
            <h3>💬 WhatsApp Business</h3>
            <p>
              Engage customers through WhatsApp with order notifications,
              customer support, promotional campaigns, and automated messaging.
            </p>
          </div>

          <div className="service-card">
            <h3>⚙ Business Automation</h3>
            <p>
              Integrate multiple platforms and automate workflows to improve
              efficiency and reduce manual work.
            </p>
          </div>

        </div>

      </section>

    </div>
    )
};
export default Home;